var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { GetArtificialNotificationAddressListQuery, NotificationPreferencesClient, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Prop, Vue, Watch, Ref } from "vue-facing-decorator";
import CompanyNotificationSummaryVue from "@/app/vues/company/company-notification-summary.vue";
import { LoginState } from "@/app/store/modules/login.state";
import { State } from "vuex-facing-decorator";
const notificationPreferencesClient = new NotificationPreferencesClient(window.apiUrl);
let ArtificialNotificationAddressesVue = class ArtificialNotificationAddressesVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        this.lowerSystemDigestInterval = 1;
        this.upperSystemDigestInterval = 30;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "DisplayName",
            direction: SortDirection.Descending
        }));
        // models
        this.data = [];
        this.query = new GetArtificialNotificationAddressListQuery({
            companyId: 0,
            keywords: null,
            sort: this.sorter.currentSort
        });
    }
    created() {
        var _a;
        this.query.companyId = (_a = this.companyId) !== null && _a !== void 0 ? _a : this.query.companyId;
    }
    ;
    mounted() {
    }
    ;
    search() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            if (!this.query.companyId) {
                Notifier.onWarning(`Please select a company before viewing notification contacts.`);
                return;
            }
            this.working = true;
            return yield notificationPreferencesClient.searchArtificialNotificationAddresses(this.query)
                .then(response => {
                if (!response)
                    return;
                this.data = response;
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.searchAttempted = true;
            });
        });
    }
    ;
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.sort = this.sorter.currentSort;
            yield this.search();
        });
    }
    ;
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.search();
        });
    }
    ;
    validateNotifications() {
        if (this.working || !this.data)
            return false;
        if (!this.notificationsSummary.validate()) {
            return false;
        }
        // Validate notification items
        for (var i = 0; i < this.data.length; i++) {
            let item = this.data[i];
            if (!this.isPowerShield) {
                if (item.systemDigestNotificationIntervalInDays < this.lowerSystemDigestInterval) {
                    Notifier.onWarning(`Contact: ${item.displayName}: Summary Interval (Days) cannot be less than ${this.lowerSystemDigestInterval} day`);
                    return false;
                }
                if (item.systemDigestNotificationIntervalInDays > this.upperSystemDigestInterval) {
                    Notifier.onWarning(`Contact: ${item.displayName}: Summary Interval (Days) cannot be longer than ${this.upperSystemDigestInterval} days`);
                    return false;
                }
            }
        }
        return true;
    }
    disableIntervalInput(item) {
        return !item.sendSystemDigestEmails;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data);
    }
    ;
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
    get displayedSummaryNotificationIntervalType() {
        return this.isPowerShield ? "Minutes" : "Days";
    }
    ;
    get selectPlaceholder() {
        return "Select Option";
    }
    getNotifications() {
        // prepare data
        this.data.forEach(item => {
            var _a, _b;
            // Powershield users set internvals in minutes, all other users use days.
            item.systemDigestNotificationInterval = this.isPowerShield
                ? Math.round(((_a = item.systemDigestNotificationIntervalInMinutes) !== null && _a !== void 0 ? _a : 1) * 60)
                : Math.round(((_b = item.systemDigestNotificationIntervalInDays) !== null && _b !== void 0 ? _b : 1) * 60 * 60 * 24);
            item.systemDigestNotificationIntervalInDays = item.systemDigestNotificationInterval / (60 * 60 * 24);
            item.systemDigestNotificationIntervalInMinutes = item.systemDigestNotificationInterval / 60;
        });
        return this.data;
    }
    get maxDailyAlarmEmailLimitPerSystem() {
        return this.notificationsSummary ? this.notificationsSummary.maxDailyAlarmEmailLimitPerSystem : 0;
    }
    get maxDailyAlarmSmsLimitPerSystem() {
        return this.notificationsSummary ? this.notificationsSummary.maxDailyAlarmSmsLimitPerSystem : 0;
    }
    /// Whether the daily limits were actually edited on this visit - see the summary panel.
    get limitsWereEdited() {
        return this.notificationsSummary ? this.notificationsSummary.limitsWereEdited : false;
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], ArtificialNotificationAddressesVue.prototype, "loginState", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], ArtificialNotificationAddressesVue.prototype, "notificationsSummary", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], ArtificialNotificationAddressesVue.prototype, "companyId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], ArtificialNotificationAddressesVue.prototype, "showTitle", void 0);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], ArtificialNotificationAddressesVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], ArtificialNotificationAddressesVue.prototype, "onSortChanged", null);
ArtificialNotificationAddressesVue = __decorate([
    Component({
        name: "ArtificialNotificationAddressesVue",
        components: {
            CompanyNotificationSummaryVue
        },
        expose: ["reload", "validateNotifications", "getNotifications", "maxDailyAlarmEmailLimitPerSystem", "maxDailyAlarmSmsLimitPerSystem", "limitsWereEdited"]
    })
], ArtificialNotificationAddressesVue);
export default ArtificialNotificationAddressesVue;
